import Route from '@ember/routing/route'
import { service } from '@ember/service'
import type WritingLegendsCatalogueService from 'teacher-ui-client/services/writing-legends-catalogue'

interface Params extends Record<string, unknown> {
  activity_id: string
}

export interface LongWritesActivity {
  activity_id: string
  title: string
  description: string
  thumbnail?: string
  template: string
  blocks: {
    block_id: string
    content: string
    block_type: string
    lexorank?: string
  }[]
}

export default class LongWritesPreviewsRoute extends Route {
  @service writingLegendsCatalogue!: WritingLegendsCatalogueService

  async model(params: Params) {
    const activity = await this.writingLegendsCatalogue.fetchData<LongWritesActivity>(
      this.writingLegendsCatalogue.buildActivityUrl(params.activity_id),
    )
    return {
      params,
      activity,
    }
  }
}
